import { AxiosResponse } from "axios";

const axiosOnSuccessEvent = (response: AxiosResponse) => {
    if (typeof document !== "undefined") {
        try {
            document.dispatchEvent(
                new CustomEvent("ajaxComplete", {
                    detail: response,
                })
            );
        } catch (error) {
            // TODO: Handle error
        }
    }
};

export default axiosOnSuccessEvent;
